import {OperatingHours} from "@back/models/agency-schedule";

export interface Agency {
  id: number,
  business_name: string;
  company_name: string;
  vat_number: number;
  operational_unit: string;
  email: string;
  contact_first_name: string;
  contact_last_name: string;
  document_number: string;
  phone_number: string;
  address_id: number;
  country: CountryData;
  emergency_phone_number: string;
  deferred_payment_allowed: boolean;
  deferred_days: number;
  logo_url: string;
  logo_content_type: string;
  tenant_id: number;
  address: AgencyAddress;
  branches: AgencyBranch[];
  is_branch: boolean;
  operating_hours: OperatingHours[];
}

export interface AgencyBranch extends Agency {
  parent_id: number;
  tc_domain: string;
  theme_color: string;
  updated_source: string;
}

interface AgencyAddress {
  id: number;
  street: string;
  zip: string;
  city: string;
  province: string;
  region: string;
  nation: string;
  lat: string;
  lng: string;
}

export interface GetAgencyPayload {
  search: string;
  page: number;
  limit: number
}

export type { SocialPlatform } from '@app/shared/social-media-links/social-icons';
import { SocialPlatform } from '@app/shared/social-media-links/social-icons';

export interface AgencySocialLink {
  id?: number,
  agency_id?: number,
  platform: SocialPlatform,
  url: string,
  label: string | null,
  order: number,
  icon: string
}

export type AgencySocialLinks = AgencySocialLink[];

// Some endpoints answer with a bare array, others wrap it in {data: [...]}.
export type AgencySocialLinksResponse = AgencySocialLinks | { data: AgencySocialLinks };

export function unwrapSocialLinks(response: AgencySocialLinksResponse): AgencySocialLinks {
  return Array.isArray(response) ? response : (response?.data ?? []);
}

export interface CountryData {
  id: number;
  name: string;
  selected: boolean;
  slug: string
}
